export enum ProcedureVersionStatus {
    Draft = 'Draft',
    Released = 'Released',
    Obsolete = 'Obsolete'
}